import { Button } from '@mui/material';

import styled from 'styled-components';

import { NavItemButton } from '../navigation.types';

const StyledNavButton = styled(Button)`
  &.nav-item-button {
    margin-left: ${({ theme }) => theme.spacing(2)};
    padding: ${({ theme }) => theme.spacing(0, 4)};
    width: unset;

    &:hover {
      box-shadow: none;
    }
  }
`;

export const ButtonNavItem = ({ text, buttonProps, onClick }: NavItemButton) => {
  const defaultButtonProps = { fullWidth: false };

  return (
    <StyledNavButton className="nav-item-button" {...defaultButtonProps} {...buttonProps}>
      <span className="nav-item-inner" onClick={onClick}>
        {text}
      </span>
    </StyledNavButton>
  );
};
